import { GoogleAuthProvider, signInWithPopup } from 'firebase/auth';
import { useState } from 'react';
import { Button, Card, Col, Form, Row } from 'react-bootstrap';
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import { Link, useLocation, useNavigate } from 'react-router-dom';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import Swal from 'sweetalert2';
import api from '../../apiClient';
import { auth } from '../../firebase/firebaseConfig';
import ActivataionAccount from './ActivataionAccount';
import SocialButtons from './sessions/SocialButtons';
import { default as SocialButtonsHR } from './sessions/SocialButtonsHR';
import TextField from './sessions/TextField';

const ForgetPassword = () => {
    const navigate = useNavigate();
    const location = useLocation();
    const redirectPath = location.state?.redirectPath || '/'; // Default to '/' home if no path is provided
    const [loading, setLoading] = useState(false); // State to manage loading

    function getFormattedDate() {
        const appliedOn = new Date(); // Get current date and time
        const year = appliedOn.getFullYear(); // Get the full year (e.g., 2024)
        const month = String(appliedOn.getMonth() + 1).padStart(2, '0'); // Get month (January is 0, so we add 1)
        const day = String(appliedOn.getDate()).padStart(2, '0'); // Get day of the month
        return `${year}-${month}-${day}`;
    }
    const [userEmail, setEmail] = useState('');
    const [errorMessage, setErrorMessage] = useState('');
    const [successMessage, setSuccessMessage] = useState('');
    const [otp, setOtp] = useState();
    const [newPassword, setNewPassword] = useState('');
    const [confirmPassword, setConfirmPassword] = useState('');
    const [stage, setStage] = useState('email');
    const [otpEnter, setOtpEnter] = useState('');
    const [userDeactivateErrorMsg, setUserDeactivateErrorMsg] = useState('');
    const [passwordMatchError, setPasswordMatchError] = useState(false);
    const [showActivationModal, setShowActivationModal] = useState(false);
    const [passwordCriteriaError, setPasswordCriteriaError] = useState(false);
    const [showPassword, setShowPassword] = useState(false); // Add state for password visibility
    const [showConfirmPassword, setShowConfirmPassword] = useState(false); // Add state for re-password visibility
    const handleEmailSubmit = async (e) => {
        e.preventDefault(); // Prevent default form submission

        // Check if the user exists with the provided email
        const checkUserResponse = await api.checkUser(userEmail);

        if (checkUserResponse.status === 200) {
            if (checkUserResponse.data.deActivate === true) {
                // Account is deactivated, show message to activate the account
                setUserDeactivateErrorMsg(
                    <span>
                        Your email already exists. Please{' '}
                        <Link
                            to="#"
                            onClick={(e) => {
                                e.preventDefault(); // Prevent default link behavior
                                localStorage.setItem('redirectAfterLogin', 'forget-password');
                                setShowActivationModal(true); // Show the activation modal
                            }}
                        >
                            Activate Your Account
                        </Link>{' '}
                        to log in to your account and then proceed to reset your password.
                    </span>
                );
            } else {
                // Account is active, proceed to reset password
                toast.success('Verification code sent to your email. Please check your inbox.', {
                    position: "top-right",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                });
                try {
                    const response = await api.otpGenerate(userEmail);
                    if (response.data) {
                        setOtp(response.data);
                        setStage('otp'); // Proceed to OTP stage

                    } else {
                        setErrorMessage("Invalid Email");
                    }
                } catch (error) {
                }
            }
        } else {
            // Email does not exist, prompt to register
            setUserDeactivateErrorMsg(
                <span>
                    This email does not exist. Please{' '}
                    <Link to="/">Register yourself</Link> first.
                </span>
            );
        }
    };

    const handleOtpSubmit = (e) => {
        e.preventDefault();

        if (otp == otpEnter) {
            setStage('resetPassword');
        } else {
            setErrorMessage("Invalid OTP");
        }
    };

    const handlePasswordReset = async (e) => {
        e.preventDefault();
        if (!validatePassword()) {
            return;
        }
        try {
            const response = await api.updatePassword(userEmail, newPassword);
            if (response.data) {
                setSuccessMessage("Password reset successfully! Now you can login with your new password.");
            } else {
                setErrorMessage('');
                setPasswordMatchError(false);
                setPasswordCriteriaError(false);
            }
        } catch (error) {
        }
    };

    const validatePassword = () => {
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+])[A-Za-z\d!@#$%^&*()_+]{8,20}$/;
        const isValidPassword = passwordRegex.test(newPassword) && newPassword === confirmPassword;

        if (!isValidPassword) {
            if (newPassword !== confirmPassword) {
                setPasswordMatchError(true);
            } else if (newPassword.length < 8 || newPassword.length > 20) {
                setPasswordCriteriaError(true);
            } else {
                setPasswordCriteriaError(true);
            }
            return false;
        }
        return true;
    };

    // Google Sign-In Handle
    const signInWithGoogle = async () => {
        const provider = new GoogleAuthProvider();
        provider.setCustomParameters({ prompt: "select_account" });

        try {
            const result = await signInWithPopup(auth, provider);
            const user = result.user;
            const userEmail = user.email;

            // Check if the user exists in the backend
            const response = await api.checkUserWithToken(userEmail);
            const existingUser = response.data.user;
            const token = response.data.token;
            setLoading(true);
            if (existingUser && token) {
                // Store token in localStorage
                localStorage.setItem('token', token);
                localStorage.setItem('user', JSON.stringify(existingUser));

                // Store user data and token in cookies
                const domain = window.location.hostname === 'localhost' ? 'localhost' : 'jobbox.one';
                document.cookie = `user=${JSON.stringify(existingUser)}; path=/; domain=${domain}; secure; samesite=strict;`;
                document.cookie = `token=${token}; path=/; domain=${domain}; secure; samesite=strict;`;

                // Navigate to dashboard
                Swal.fire({
                    icon: 'success',
                    title: 'Welcome Back!',
                    text: 'You are already registered. Click here to go to your dashboard.',
                    confirmButtonText: 'OK',
                }).then((result) => {
                    if (result.isConfirmed) {
                        navigate('/candidate-dashboard', { state: { userId: existingUser.userId, userName: existingUser.userName } });
                    }
                });
            } else {
                setLoading(true); // Start loading
                // Handle new user registration
                const randomPassword = Math.random().toString(36).slice(-8);
                const newUser = {
                    userName: user.displayName,// Ensure userName is set
                    userEmail: userEmail,
                    password: randomPassword,
                    userRole: 'Candidate',
                    appliedDate: getFormattedDate(),
                };

                // Save new user to the backend
                const saveResponse = await api.saveUser(newUser);

                if (saveResponse.status === 201) {
                    const response = await api.checkUserWithToken(userEmail);
                    const registeredUser = response.data.user;
                    const token = response.data.token;

                    if (registeredUser && token) {
                        localStorage.setItem('token', token);
                        localStorage.setItem('user', JSON.stringify(registeredUser));

                        const domain = window.location.hostname === 'localhost' ? 'localhost' : 'jobbox.one';
                        document.cookie = `user=${JSON.stringify(registeredUser)}; path=/; domain=${domain}; secure; samesite=strict;`;
                        document.cookie = `token=${token}; path=/; domain=${domain}; secure; samesite=strict;`;

                        Swal.fire({
                            icon: "success",
                            title: "Registration Successful!",
                            text: "Your account has been created. Click here to go to your dashboard.",
                            confirmButtonText: "OK",
                        }).then((result) => {
                            if (result.isConfirmed) {
                                navigate("/candidate-dashboard", {
                                    state: { userId: registeredUser.userId, userName: registeredUser.userName },
                                });
                            }
                        });
                    } else {
                        Swal.fire({
                            icon: "error",
                            title: "Registration Failed!",
                            text: "An error occurred while creating your account. Please try again.",
                            confirmButtonText: "OK",
                        });
                    }
                }
            }
        }

        catch (error) {
            setErrorMessage("Error signing in with Google.");
        }
    };
    return (
        <div
  className="auth-layout-wrap"
  style={{
    backgroundImage:
      'linear-gradient(rgba(5,15,35,0.72), rgba(0,10,30,0.78)), url("/candidate.jpg")',
    backgroundSize: "cover",
    backgroundPosition: "center",
    backgroundRepeat: "no-repeat",
    minHeight: "100vh",
  }}
>
  <ToastContainer />

  <div className="auth-content">
    {redirectPath === "/hr-sign-in" ? (
      <Link to="/hr-signup">
        <Button className="mb-3">
          [ New employer/HR Register here ]
        </Button>
      </Link>
    ) : (
      <Link to="/candidate-signup">
        <Button className="mb-3">
          [ New Candidate Register here ]
        </Button>
      </Link>
    )}

    <Card className="o-hidden card bg-transparent border-0 shadow-none">
      <Row>
        {/* LEFT SIDE */}
        <Col md={6}>
          <div className="auth-logo text-center mb-4">
            <img
              src="/jb_logo.png"
              alt="JobDB"
              style={{
                height: "100px",
                width: "250px",
                overflow: "scroll",
              }}
            />
          </div>

          <div className="p-4">
            <h1
              className="mb-3 text-18 fw-bold"
              style={{
                color: "#ffffff",
                textShadow:
                  "0 0 10px rgba(0,180,255,0.6)",
              }}
            >
              Forget Password
            </h1>

            <div className="forgetpassword-container">
              {/* EMAIL */}
              {stage === "email" && (
                <Form onSubmit={handleEmailSubmit}>
                  <Form.Group
                    className="mb-3"
                    controlId="email"
                  >
                    <Form.Label
                      style={{
                        color: "#ffffff",
                      }}
                    >
                      Enter your email:
                    </Form.Label>

                    <Form.Control
                      type="email"
                      value={userEmail}
                      onChange={(e) =>
                        setEmail(e.target.value)
                      }
                      required
                      style={{
                        background:
                          "rgba(255,255,255,0.08)",
                        color: "#ffffff",
                        border:
                          "1px solid rgba(255,255,255,0.25)",
                      }}
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                  >
                    Submit
                  </Button>
                </Form>
              )}

              {userDeactivateErrorMsg && (
                <div className="text-danger">
                  {userDeactivateErrorMsg}
                </div>
              )}

              {/* OTP */}
              {stage === "otp" && (
                <Form onSubmit={handleOtpSubmit}>
                  <Form.Group
                    className="mb-3"
                    controlId="otp"
                  >
                    <Form.Label
                      style={{
                        color: "#ffffff",
                      }}
                    >
                      Enter OTP:
                    </Form.Label>

                    <TextField
                      type="text"
                      value={otpEnter}
                      onChange={(e) => {
                        const value =
                          e.target.value;

                        if (
                          /^\d{0,6}$/.test(value)
                        ) {
                          setOtpEnter(value);
                        }
                      }}
                      required
                    />
                  </Form.Group>

                  <Button
                    variant="primary"
                    type="submit"
                  >
                    Submit
                  </Button>

                  {errorMessage && (
                    <div className="error-message mt-2">
                      {errorMessage}
                    </div>
                  )}
                </Form>
              )}

              {/* RESET PASSWORD */}
              {stage ===
                "resetPassword" && (
                <Form
                  onSubmit={
                    handlePasswordReset
                  }
                >
                  <div className="position-relative">
                    <Form.Group
                      className="mb-3"
                      controlId="newPassword"
                    >
                      <Form.Label
                        style={{
                          color:
                            "#ffffff",
                        }}
                      >
                        New Password:
                      </Form.Label>

                      <Form.Control
                        type={
                          showPassword
                            ? "text"
                            : "password"
                        }
                        value={
                          newPassword
                        }
                        onChange={(
                          e
                        ) => {
                          setNewPassword(
                            e.target
                              .value
                          );
                          setPasswordCriteriaError(
                            ""
                          );
                          setPasswordMatchError(
                            ""
                          );
                        }}
                        required
                        style={{
                          background:
                            "rgba(255,255,255,0.08)",
                          color:
                            "#ffffff",
                          border:
                            "1px solid rgba(255,255,255,0.25)",
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute"
                        style={{
                          right:
                            "10px",
                          top: "50%",
                          transform:
                            "translateY(-50%)",
                          padding:
                            "0",
                          color:
                            "#9fdcff",
                          zIndex:
                            "1",
                          background:
                            "transparent",
                          border:
                            "none",
                          cursor:
                            "pointer",
                        }}
                        onClick={() =>
                          setShowPassword(
                            !showPassword
                          )
                        }
                      >
                        {showPassword ? (
                          <FaEyeSlash
                            size={
                              18
                            }
                          />
                        ) : (
                          <FaEye
                            size={
                              18
                            }
                          />
                        )}
                      </button>
                    </Form.Group>
                  </div>

                  <div className="position-relative">
                    <Form.Group
                      className="mb-3"
                      controlId="confirmPassword"
                    >
                      <Form.Label
                        style={{
                          color:
                            "#ffffff",
                        }}
                      >
                        Confirm Password:
                      </Form.Label>

                      <Form.Control
                        type={
                          showConfirmPassword
                            ? "text"
                            : "password"
                        }
                        value={
                          confirmPassword
                        }
                        onChange={(
                          e
                        ) => {
                          setConfirmPassword(
                            e.target
                              .value
                          );
                          setPasswordCriteriaError(
                            ""
                          );
                          setPasswordMatchError(
                            ""
                          );
                        }}
                        required
                        style={{
                          background:
                            "rgba(255,255,255,0.08)",
                          color:
                            "#ffffff",
                          border:
                            "1px solid rgba(255,255,255,0.25)",
                        }}
                      />

                      <button
                        type="button"
                        className="btn btn-link position-absolute"
                        style={{
                          right:
                            "10px",
                          top: "50%",
                          transform:
                            "translateY(-50%)",
                          padding:
                            "0",
                          color:
                            "#9fdcff",
                          zIndex:
                            "1",
                          background:
                            "transparent",
                          border:
                            "none",
                          cursor:
                            "pointer",
                        }}
                        onClick={() =>
                          setShowConfirmPassword(
                            !showConfirmPassword
                          )
                        }
                      >
                        {showConfirmPassword ? (
                          <FaEyeSlash
                            size={
                              18
                            }
                          />
                        ) : (
                          <FaEye
                            size={
                              18
                            }
                          />
                        )}
                      </button>
                    </Form.Group>
                  </div>

                  {passwordCriteriaError && (
                    <p className="error-message">
                      Password must be 8
                      to 20
                      characters
                    </p>
                  )}

                  {passwordMatchError && (
                    <p className="error-message">
                      Password and
                      confirm password
                      do not match
                    </p>
                  )}

                  <Button
                    variant="primary"
                    type="submit"
                  >
                    Reset Password
                  </Button>

                  {successMessage && (
                    <div className="success-message mt-2">
                      {
                        successMessage
                      }

                      <br />

                      <Link
                        to={
                          redirectPath
                        }
                        className="btn btn-link"
                      >
                        Login
                      </Link>
                    </div>
                  )}
                </Form>
              )}
            </div>
          </div>

          {showActivationModal && (
            <ActivataionAccount
              userEmail={userEmail}
              onClose={() =>
                setShowActivationModal(
                  false
                )
              }
            />
          )}
        </Col>

        {/* RIGHT SIDE */}
        <Col
          md={6}
          className="text-center auth-cover"
        >
          <div className="pe-3 auth-right">
            {redirectPath ===
            "/hr-sign-in" ? (
              <SocialButtonsHR
                routeUrl="/hr-signup"
                isLogin={false}
              />
            ) : loading ? (
              <div className="loader">
                Loading...
              </div>
            ) : (
              <SocialButtons
                isLogin={false}
                routeUrl="/candidate-signup"
                googleHandler={
                  signInWithGoogle
                }
              />
            )}
          </div>
        </Col>
      </Row>
    </Card>
  </div>
</div>
    );
}

export default ForgetPassword;
